var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","hide-details":"auto","dense":"","background-color":"background_color","prepend-inner-icon":"mdi-lock-outline","append-icon":_vm.oldPassword ? 'mdi-eye' : 'mdi-eye-off',"type":_vm.oldPassword ? 'text' : 'password',"label":`${_vm.label} ${_vm.required ? ' *' : ''}`,"rules":[
    ...(_vm.required ? [(val) => !!val || `${_vm.label} is required`] : []),
    ..._vm.rules,
  ],"autocomplete":"new-password"},on:{"click:append":function($event){_vm.oldPassword = !_vm.oldPassword}}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }